package com.wintermar.inspection.core.ui.theme.color.palette.accent

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val MagentaColorVariant = ColorVariant(
    n100 = Color(0xFFFFECF8),
    n200 = Color(0xFFFDD0EC),
    n300 = Color(0xFFF797D2),
    n400 = Color(0xFFE774BB),
    n500 = Color(0xFFDA62AC),
    n600 = Color(0xFFCD519D),
    n700 = Color(0xFFAE4787),
    n800 = Color(0xFF943D73),
    n900 = Color(0xFF50253F),
    n1000 = Color(0xFF3D2232)
)
